import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { ColourCombination } from './useColours';

type UseColourCombinationCatalogOptions = {
  includeHidden?: boolean;
};

export function useColourCombinationCatalog(
  options: UseColourCombinationCatalogOptions = {}
) {
  const { includeHidden = false } = options;
  const [combinations, setCombinations] = useState<ColourCombination[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function load() {
      setLoading(true);
      let query = supabase.from('colour_combinations').select('*');
      if (!includeHidden) {
        query = query.eq('is_visible', true);
      }
      const { data, error } = await query.order('finish_type', { ascending: true });
      if (!active) return;
      if (error) {
        setCombinations([]);
        setLoading(false);
        return;
      }
      setCombinations((data ?? []) as ColourCombination[]);
      setLoading(false);
    }

    void load();

    return () => {
      active = false;
    };
  }, [includeHidden]);

  return {
    combinations,
    loading,
  };
}
